<template>
  <div class="content-menu" ref="imageContainer" @contextmenu.prevent="handleContextmenu">
    <slot></slot>
    <transition name="fade">
      <div v-if="isMenuVisible" class="context-menu" :style="menuPosition">
        <div @click.stop="downloadImage">
          <span class="menu-icon hitems-download"></span>
          下载
        </div>
        <div @click.stop="copyImageFn">
          <span class="menu-icon hitems-copy"></span>
          复制
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
  import { ref, onBeforeUnmount, onMounted, inject } from 'vue'
  import LongTouchPlugin from '@common/utils/longTouch'
  import type { ToastServiceType } from '@components/components/AppToast/toast'
  import { copyImage } from '@common/utils/common'
  // 定义 props
  const props = defineProps<{
    imageId: string
    topicId?: string
  }>()

  const $toast = inject<ToastServiceType>('$toast')
  const imageContainer = ref<HTMLElement | null>(null)
  const isMenuVisible = ref(false)
  const menuPosition = ref({ top: '0px', left: '0px' })
  const handleContextmenu = (event: MouseEvent) => {
    event.preventDefault()
    menuPosition.value = {
      top: `${event.clientY}px`,
      left: `${event.clientX + 10}px`
    }
    isMenuVisible.value = true
  }

  const longTouchCallback = (event: TouchEvent) => {
    event.preventDefault()
    menuPosition.value = {
      top: `${event.touches[0].clientY}px`,
      left: `${event.touches[0].clientX + 10}px`
    }
    isMenuVisible.value = true
  }
  const longTouchDuration = 500
  const longTouchPlugin = new LongTouchPlugin(longTouchDuration, longTouchCallback)

  const getImageBase64 = (image: any) => {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const ctx = canvas.getContext('2d')
    ctx?.drawImage(image, 0, 0, image.width, image.height)
    // 获取图片后缀名
    const extension = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase() || 'png'
    // 某些图片 url 可能没有后缀名，默认是 png
    return canvas.toDataURL('image/' + extension, 1)
  }

  const downloadImage = () => {
    const link = document.createElement('a')
    link.href = `/aigc/api/download/image?uniqueImageId=${props.imageId}&topicId=${props.topicId || ''}`
    link.target = '_blank'
    link.download = 'download.png'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    isMenuVisible.value = false

    // const url = props.url;
    // const link = document.createElement('a')
    // link.setAttribute('download', url)
    // const image = new Image()
    // // 添加时间戳，防止浏览器缓存图片
    // image.src = url + '?timestamp=' + new Date().getTime()
    // // 设置 crossOrigin 属性，解决图片跨域报错
    // image.setAttribute('crossOrigin', 'Anonymous')
    // image.onload = () => {
    //     link.href = getImageBase64(image)
    //     link.click();
    // }
    // isMenuVisible.value = false;
    $toast &&
      $toast({
        message: '下载中',
        type: 'success'
      })
  }

  const copyImageFn = async () => {
    $toast &&
      $toast({
        message: '复制中...',
        type: 'success'
      })
    isMenuVisible.value = false
    await copyImage(
      `/aigc/api/download/image?uniqueImageId=${props.imageId}&topicId=${props.topicId || ''}`
    )
    $toast &&
      $toast({
        message: '图片已复制',
        type: 'success'
      })
  }

  const hideMenu = () => {
    if (imageContainer.value) {
      isMenuVisible.value = false
    }
  }

  onMounted(() => {
    document.addEventListener('click', hideMenu)
    imageContainer.value && longTouchPlugin.init(imageContainer.value)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', hideMenu)
  })
</script>

<style scoped>
  .context-menu {
    position: fixed;
    width: 16.4rem;
    overflow: hidden;
    z-index: 102;
    background-color: #333;
    border-radius: 1rem;
    color: #fff;
    font-size: 1.6rem;
  }

  .context-menu div {
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: start;
    cursor: pointer;
    font-style: normal;
    padding-left: 2rem;
  }

  .menu-icon {
    font-size: 1.8rem;
    margin-right: 1rem;
  }

  .context-menu div:hover {
    background-color: #101010;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
